<template>
  <div class="signup-enter-code padding-top-ml">
    <div class="content">
      <div class="ri-medium-bold-headline">
        מה הקוד החד פעמי שקיבלת?
      </div>

      <enter-code
        class="enter-code"
        :first-name="firstName"
        :phone-number="phoneNumber"
        :confirm-code-action="onCodeEntered"
        :regenerate-code-action="() => authenticationStore.generateCode(phoneNumber, true)"
        :server-error="errorLabel"
        :button-title="'אישור'"
        :loading="loading || authLoading"
        :reset-error="resetError"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { ref } from 'vue';
import moment from 'moment';
import EnterCode from '../../Login/EnterCode.vue';
import { useSignupStore } from '../../../stores/signup';
import { useAuthenticationStore } from '../../../stores/authentication';
import { parseAuthenticationError } from '../../../utils/LoginErrorParser';
import Segment from '../../../Segment';
import { useChallengeStore } from '../../../stores/challenge';

const errorLabel = ref<string>('');
const signupStore = useSignupStore();
const authenticationStore = useAuthenticationStore();
const challengeStore = useChallengeStore();
const { loading: authLoading } = storeToRefs(authenticationStore);
const { firstName, phoneNumber, loading } = storeToRefs(signupStore);
const { challenge } = storeToRefs(challengeStore);
Segment.trackUserGot('Signup_EnterCode_Shown');

interface Props {
  continueAfterSignup(): void;
}
const props = defineProps<Props>();
function resetError() {
  errorLabel.value = '';
}
async function onCodeEntered(code: string) {
  Segment.trackUserInteraction('Signup_EnterCode_CodeEntered');
  try {
    const { riseupAccountId, challenger } = await authenticationStore.authenticate(phoneNumber.value, code);
    const challengeTag = `${challenge.value.name}_${moment(challenge.value.startDate).format('YYYY-MM-DD')}`;
    await signupStore.signup(challengeTag, riseupAccountId, challenger);
    props.continueAfterSignup();
  } catch (e) {
    errorLabel.value = parseAuthenticationError(e);
    Segment.trackUserGot('Signup_EnterCode_Error', { errorLabel: errorLabel.value });
  }
}
</script>
<style lang="scss" scoped>
@import '@riseupil/base-ui/src/scss/mixins';
@import "base-ui-vue3/src/scss/riseup-colors";

  .signup-enter-code {
    @include white-page-frame;
    @include responsive-padding;
    flex: 1;
    width: 100%;

    .content {
      width: 100%;
    }

    .enter-code {
      width: 100%;
    }
  }

</style>
